import FilterContainer from 'components/filters/FilterContainer';
import styled from 'styled-components';

export const InboxFilterFormContainer = styled(FilterContainer)`
  padding-bottom: 0.5em;
  margin-bottom: 1.5em;
`;
